import { Color } from "three";
/*
 * Created by C.J. Kimberlin (http://cjkimberlin.com)
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2015
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
new Color();
export class ColorHSV {
    constructor(h, s, v) {
        this.h = h;
        this.s = s;
        this.v = v;
    }
    //HSV lerp written by Alan Zucconi.
    static lerpHSV(a, b, t) {
        // Hue interpolation
        let h = 0;
        let d = b.h - a.h;
        if (a.h > b.h) {
            // Swap (a.h, b.h)
            /*var h3 = b.h;
            b.h = a.h;
            a.h = h3;*/
            var c = a;
            a = b;
            b = c;
            d = -d;
            t = 1 - t;
        }
        if (d > 0.5) // 180deg
         {
            a.h = a.h + 1; // 360deg
            h = (a.h + t * (b.h - a.h)) % 1; // 360deg
        }
        if (d <= 0.5) // 180deg
         {
            h = a.h + t * d;
        }
        // Interpolates the rest
        return new ColorHSV(h, // H
        a.s + t * (b.s - a.s), // S
        a.v + t * (b.v - a.v));
    }
    toString() {
        return `HSVA: (${this.h}, ${this.s}, ${this.v})`;
    }
    static hueToRgb(h) {
        const r = Math.abs(h * 6 - 3) - 1;
        const g = 2 - Math.abs(h * 6 - 2);
        const b = 2 - Math.abs(h * 6 - 4);
        return { r: Math.max(0, Math.min(1, r)), g: Math.max(0, Math.min(1, g)), b: Math.max(0, Math.min(1, b)) };
    }
    toHex() {
        let { r, g, b } = ColorHSV.hueToRgb(this.h);
        r = (r - 1) * this.s + 1;
        g = (g - 1) * this.s + 1;
        b = (b - 1) * this.s + 1;
        return (Math.floor(r * 255) << 16) + (Math.floor(g * 255) << 8) + Math.floor(b * 255);
    }
    static fromHex(hex) {
        return this.fromRGB((hex >> 16) % 256, (hex >> 8) % 256, hex % 256);
    }
    static fromRGB(r, g, b) {
        const divR = r / 255;
        const divG = g / 255;
        const divB = b / 255;
        const CMax = Math.max(divR, divG, divB);
        const CMin = Math.min(divR, divG, divB);
        const delta = CMax - CMin;
        let hue = 0;
        let sat = 0;
        if (delta > 0) {
            if (CMax === divR) {
                hue = (((divG - divB) / delta) % 6) / 6;
            }
            else if (CMax === divG) {
                hue = ((divB - divR) / delta + 2) / 6;
            }
            else if (CMax === divB) {
                hue = ((divR - divG) / delta + 4) / 6;
            }
            sat = delta / CMax;
        }
        return new ColorHSV(hue, sat, CMax);
    }
}
//# sourceMappingURL=ColorHSV.js.map